<template>
  <v-main>
    <v-row class="ma-0">
      <!-- Creamos las migas de pan automaticamente -->

      <v-spacer />
        <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16dTMApbdGWurQ0kC-iKrip_">
            <v-icon>mdi-video</v-icon>
        </v-btn>
    </v-row>

    <!-- Generamos el AppBar con las distintas acciones -->
    <v-app-bar color="primary" dense dark>
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn text @click="" v-on="on" :disabled="!show_cambio_empleado">
            <v-icon small>mdi-account-group</v-icon>
            <span class="appbar_button" style="text-transform: none">{{ $t('Cambiar de empleado') }}</span>
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list v-if="show_cambio_empleado">
          <v-list-item v-for="(empleado, index) in empleados" :key="index" @click="change_empleado(empleado.id)">
            <v-list-item-avatar>
              <v-img :src="empleado.foto_url_absolute_path" alt="" />
            </v-list-item-avatar>
            <v-list-item-title class="pointer">{{ empleado.nombre_completo }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-container fluid>
      <!-- Ficha del empleado -->
      <v-row class="pl-2 pr-2" v-if="empleado">

        <!-- Información básica del empleado -->
        <v-col cols="12" md="3" lg="2">
          <v-img @click="open_dialog_imagen" :src="empleado.foto_url_absolute_path" class="pointer rounded-lg elevation-4"></v-img>

          <h4 class="mt-2 text-ellipsis">{{ empleado.nombre_completo }}</h4>
          <ul class="user_data">
            <li class="text-ellipsis">
              <v-icon>mdi-domain</v-icon>
              {{ $store.state.centro.centro.nombre }}
            </li>
            <li class="text-ellipsis text-lowercase">
              <v-icon>mdi-at</v-icon>
              {{ empleado.email }}
            </li>
            <li class="text-ellipsis text-capitalize">
              <v-icon>mdi-shield-account</v-icon>
              {{ $t(tipos_empleado[empleado.tipo_empleado]) }}
            </li>
          </ul>
          <div v-if="is_self_or_admin">
            <v-btn small block color="primary" class="mt-3" @click="dialog_empleado = true">
              <v-icon dark small class="mr-2">mdi-account-edit</v-icon>
              {{ $t('Editar') }}
            </v-btn>
            <v-btn small block color="primary" class="mt-3" @click="dialog_cambiar_password = true">
              <v-icon dark small class="mr-2">mdi-lock</v-icon>
              {{ $t('Cambiar contraseña') }}
            </v-btn>
          </div>
        </v-col>

        <!-- Tabs -->
        <v-col cols="12" md="9" lg="10">
          <v-tabs v-model="active_tab" class="elevation-2" grow>

            <v-tab href="#tab-horario">
              <span class="tab_title">{{ `${$t('Horario')} / ${$t('Vacaciones')}` }}</span>
            </v-tab>

            <v-tab href="#tab-servicios" v-if="is_admin">
              <span class="tab_title">{{ $t('Servicios online') }}</span>
            </v-tab>

            <v-tab v-if="is_self_or_admin" href="#tab-comisiones">
              <span class="tab_title">{{ $t("Comisiones") }}</span>
            </v-tab>

            <v-tab v-if="is_self_or_admin || $store.getters['auth/has_permission']('view_objetivoempleado')" href="#tab-objetivos">
              <span class="tab_title">{{ $t("Objetivos") }}</span>
            </v-tab>

            <v-tab v-if="is_self_or_admin" href="#tab-propinas">
              <span class="tab_title">{{ $t("Propinas") }}</span>
            </v-tab>

            <v-tab v-if="is_self_or_admin" href="#tab-tema">
              <span class="tab_title">{{ $t("Tema") }}</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active_tab" class="elevation-2" touchless>
            <v-tab-item value="tab-horario" class="pa-4 grey lighten-5">
              <TabHorarioVacacionesEmpleado
                  v-if="active_tab==='tab-horario'"
                  :empleado="empleado"
                  :is_admin="is_admin"
              />
            </v-tab-item>

              <v-tab-item v-if="is_admin" value="tab-servicios" class="pa-4 grey lighten-5">
                <TabServiciosOnlineEmpleado
                    v-if="active_tab==='tab-servicios'"
                    :empleado="empleado"
                />
              </v-tab-item>

            <v-tab-item v-if="is_self_or_admin" value="tab-comisiones" class="pa-4 grey lighten-5">
              <TabComisionesEmpleado
                  v-if="active_tab==='tab-comisiones'"
                  :empleado="empleado"
              />
            </v-tab-item>

            <v-tab-item v-if="is_self_or_admin || $store.getters['auth/has_permission']('view_objetivoempleado')" value="tab-objetivos" class="pa-4 grey lighten-5">
              <TabObjetivosEmpleado
                  v-if="active_tab==='tab-objetivos'"
                  :empleado="empleado"
              />
            </v-tab-item>

            <v-tab-item v-if="is_self_or_admin" value="tab-propinas" class="pa-4 grey lighten-5">
              <TabPropinasEmpleado
                  v-if="active_tab==='tab-propinas'"
                  :empleado="empleado"
              />
            </v-tab-item>

            <v-tab-item v-if="is_self_or_admin" value="tab-tema" class="pa-4 grey lighten-5">
              <TabTemaEmpleado
                  v-if="active_tab==='tab-tema'"
                  :empleado="empleado"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>

    <!-- Formulario de el empleado -->
    <FormEmpleado
        v-model="dialog_empleado"
        v-if="dialog_empleado"
        :empleado="empleado"
        :is_admin="is_admin"
        @on_save="get_empleado"
    />

    <!-- Formulario de cambiar contraseña -->
    <FormPassword
        v-model="dialog_cambiar_password"
        v-if="dialog_cambiar_password"
        :id="this.empleado.id"
    />

    <!-- Formulario de cambiar imagen de perfil -->
    <FormImagenPerfil
        v-model="dialog_imagen_perfil"
        v-if="dialog_imagen_perfil"
        :empleado="this.empleado"
        @on_save="get_empleado()"
    />
  </v-main>
</template>

<script>

export default {
  name: 'FichaEmpleado',
  data: () => ({
    active_tab: "tab-horario",
    // Select de empleados activos
    empleados: [],
    // Current empleado
    empleado: null,
    tipos_empleado: {},

    // Dialogs
    dialog_empleado: false,
    dialog_cambiar_password: false,
    dialog_imagen_perfil: false,
    show_cambio_empleado: false
  }),

  methods: {

    /**
     * Recoge el empleado de la ficha.
     */
    async get_empleado() {
      try {
        this.empleado = await this.$store.dispatch('user/get_empleado', this.$route.params['id'])
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Devuelve los empleados del centro del usuario.
     */
    async get_empleados() {
      try {
        const response = await this.$store.dispatch('user/get_empleados', {
          exclude: this.$route.params['id'],
          is_active: true
        })
        this.empleados = response.results
      } catch (err) {
      }
    },

    /**
     * Cambia a otro empleado activo del centro.
     * @param id
     */
    change_empleado(id) {
      if(!this.show_cambio_empleado){return}
      this.$router.push({name: 'ficha_empleado', params: {id: id}})
      this.$router.go(0)
    },

    /**
     * Abre el dialog de cambiar la imagen de perfil.
     */
    open_dialog_imagen() {
      if (this.is_self_or_admin) {
        this.dialog_imagen_perfil = true
      } else {
        this.$snotify.warning(
          this.$t("No tienes permiso para realizar esta acción."),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },
  },

  computed: {
    is_admin: function () {
      return this.$store.state.auth.user.tipo_empleado === 'admin'
    },
    is_self_or_admin: function () {
      return this.$store.state.auth.user.tipo_empleado === 'admin' || this.$store.state.auth.user.id === this.empleado.id
    }
  },

  mounted() {
    this.get_empleado()
    this.show_cambio_empleado = this.$store.state.auth.user.tipo_empleado === 'admin'
    this.get_empleados()

    this.tipos_empleado = {
      'empleado': this.$t('Empleado'),
      'admin': this.$t('Administrador'),
      'contabilidad': this.$t('Contabilidad'),
      'marketing': this.$t('Marketing')
    }
  },

  components: {
    FormEmpleado: () => import('@/views/Configuracion/Empleados/components/FormEmpleado'),
    FormPassword: () => import('@/views/Configuracion/Empleados/components/FormPassword'),
    FormImagenPerfil: () => import('@/views/Configuracion/Empleados/components/FormImagenPerfil'),

    TabHorarioVacacionesEmpleado: () => import('@/views/Configuracion/Empleados/components/TabHorarioVacacionesEmpleado'),
    TabServiciosOnlineEmpleado: () => import('@/views/Configuracion/Empleados/components/TabServiciosOnlineEmpleado'),
    TabComisionesEmpleado: () => import('@/views/Configuracion/Empleados/components/TabComisionesEmpleado'),
    TabObjetivosEmpleado: () => import('@/views/Configuracion/Empleados/components/TabObjetivosEmpleado'),
    TabPropinasEmpleado: () => import('@/views/Configuracion/Empleados/components/TabPropinasEmpleado'),
    TabTemaEmpleado: () => import('@/views/Configuracion/Empleados/components/TabTemaEmpleado')
  }
}
</script>
<style scoped>
.v-list{
  max-height:575px;/*Se ven 10 empleados a la vez*/
  overflow-y:auto
}
</style>
